// extracted by mini-css-extract-plugin
export default {"tabsContainer":"TabSelector_tabsContainer__ITsEL","loadingContainer":"TabSelector_loadingContainer__NGf+6"};